import { Avatar, Frame, IconInterest, Separator, SpacerVertical, Typography } from '@klarna/bubble-ui';
import { AddOriginModal } from '@merchant-portal/credentials';
import { hooks as i18nHooks } from 'mage-i18n';
import React from 'react';
import styled from 'styled-components';
import { useClientIdController } from '../../controllers/ClientIdController';
import { useMidController } from '../../controllers/MidController';
import { ButtonContainer } from '../styled';
import ClientIdButton from './ClientIdButton';
import ClientKeyFields from './ClientKeyFields';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.client-id';
const MainContainer = styled.div.withConfig({ displayName: "MainContainer", componentId: "sc-1agzkkr" }) `
  display: flex;
`;
const IconContainer = styled.div.withConfig({ displayName: "IconContainer", componentId: "sc-p4ka9a" }) `
  width: 40px;
  margin-right: 20px;
`;
const TextContainer = styled.div.withConfig({ displayName: "TextContainer", componentId: "sc-1nn3flj" }) `
  margin-right: 30px;
`;
const FieldsContainer = styled.div.withConfig({ displayName: "FieldsContainer", componentId: "sc-12mdg1z" }) `
  margin: 16px 0 0 0;
`;
export default function ClientKeyInstructions() {
    const t = i18nHooks.useTranslator();
    const { selectedMid } = useMidController();
    const { isAddOriginModalVisible, onAddOriginSuccess, setIsAddOriginModalVisible } = useClientIdController();
    return (React.createElement(Frame, null,
        React.createElement(MainContainer, null,
            React.createElement(IconContainer, null,
                React.createElement(Avatar, { icon: IconInterest, medium: true })),
            React.createElement(TextContainer, null,
                React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/bold' }, t(`${TRANSLATION_PREFIX}.title`)),
                React.createElement(SpacerVertical, { spaceToken: 'space.100' }),
                React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/regular' }, t(`${TRANSLATION_PREFIX}.content`)),
                React.createElement(FieldsContainer, null,
                    React.createElement(ClientKeyFields, null))),
            React.createElement(ButtonContainer, null,
                React.createElement(ClientIdButton, null))),
        React.createElement(SpacerVertical, { spaceToken: 'space.200' }),
        selectedMid &&
            React.createElement(AddOriginModal, { mid: selectedMid, onSuccess: onAddOriginSuccess, isVisible: isAddOriginModalVisible, setIsVisible: setIsAddOriginModalVisible }),
        React.createElement(Separator, { colorToken: "colors/backgrounds/subtle-floating" })));
}
